import React from "react";
import GeometryEditing from "../geometry-editing";
import { useAppSelector } from "../../../../../hooks/useAppSelector";

const GeometryDivider = () => {
  const { selectedCity } = useAppSelector(
    (state) => state.masterPlanModification,
  );

  return (
    <GeometryEditing
      modalMessages={{
        positive: "editing-block.modalMessagePositiveMerger",
        negative: "editing-block.modalMessageNegativeMerger",
      }}
      modalTitle="editing-block.modalTitleDivider"
      validationFlags={{
        selfIntersections: true,
        duplicatePoints: true,
        intersections: true,
        outsideCityBoundary: {
          cityId: selectedCity!,
        },
        initialIntersections: true,
      }}
      visibleAddNewPlotBtn={true}
      visibleDeletePlotBtn={true}
      addEmptyContourOnMount={true}
    />
  );
};

export default GeometryDivider;
